import React from 'react';
import { Link } from 'react-router-dom';

const ReportLink = ({ to, children, className = '', newTab = false, title, onClick }) => (
  <Link
    to={to}
    title={title}
    target={newTab ? '_blank' : undefined}
    rel={newTab ? 'noopener noreferrer' : undefined}
    onClick={onClick}
    className={`font-semibold text-orange-700 hover:text-orange-800 hover:underline ${className}`.trim()}
  >
    {children}
  </Link>
);

export default ReportLink;

